import { MouseEvent } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CompanyIcon from '@/components/Icons/CompanyIcon';
import { useEllipsisStyles } from '@/hooks/useEllipsisStyles';

const buttonStyles = {
	'& .MuiButton-startIcon': {
		m: {
			xs: '0',
			md: '0 8px 0 0',
		},
	},
	minWidth: 'max-content',
	p: {
		xs: '0',
		md: '12px',
	},
	ml: {
		xs: '15px',
		md: '20px',
	},
};

export default function BillingProfileMenuButton({
	name,
	city,
	state,
	openAccountMenu,
}: Readonly<{
	name: string | undefined;
	city: string | undefined;
	state: string | undefined;
	openAccountMenu: (event: MouseEvent<HTMLElement>) => void;
}>) {
	const ellipsisStyles = useEllipsisStyles();
	return (
		<Button
			sx={buttonStyles}
			aria-haspopup="true"
			onClick={openAccountMenu}
			startIcon={
				<Avatar
					component="span"
					sx={{
						bgcolor: 'primary.main',
						color: 'white.main',
						width: '30px',
						height: '30px',
						my: 'auto',
					}}
				>
					<CompanyIcon sx={{ fontSize: '18px' }} />
				</Avatar>
			}
			data-testid="billing-profile-menu-button"
		>
			<Typography
				component="span"
				variant="productInfo"
				sx={{
					...ellipsisStyles,
					display: { xs: 'none', md: 'block' },
					fontWeight: 700,
					whiteSpace: 'nowrap',
					maxWidth: '40ch',
				}}
				color="black.main"
				textAlign="left"
			>
				{name}
				<br />
				{city}, {state}
			</Typography>
		</Button>
	);
}
